import React from 'react';
import { Route, Redirect } from 'react-router';
import { connect } from 'react-redux';

import Header from './Header';
import NavMenu from './NavMenu';
import { HasPermissions } from '../HasPermissions'



function getQueryVariable(variable) {
	var query = window.location.search.substring(1);
	console.log(query)//"app=article&act=news_content&aid=160990"
	var vars = query.split("&");
	console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split("=");
		console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ] 
		if (pair[0] == variable) { return pair[1]; }
	}
	return (false);
}

const AppLayoutRoute = ({ component: Component, pageName: PageName, accessRule: AccessRule, ...rest, permissions }) => {
	const embed = getQueryVariable("embed");

	var contentClassName = "content content-" + PageName;
	if (embed === "true") {
		contentClassName += " content-embedded"
	}

	//let globalTheme = "theme1";

	//var customTheme = localStorage.getItem('bince-theme');
	//if (customTheme == null) {
	//	customTheme = globalTheme;
	//	localStorage.setItem('bince-theme', customTheme);
	//}
	//else {
	//	globalTheme = customTheme;
	//}	

	if (embed === "true") {
		return (
			<div>
				<Route {...rest} render={matchProps => (
					AccessRule === undefined || HasPermissions(AccessRule, permissions) ?
						<div id="wrapper" className="App">
							<div className={contentClassName}>
								<Component {...matchProps} />
							</div>

						</div> : <Redirect to="/" />)} />
			</div>
		);
	}

	return (
		<div>
			<Header logoUrl={rest.logoUrl} />

			<Route {...rest} render={matchProps => (
				AccessRule === undefined || HasPermissions(AccessRule, permissions) ?
					<div id="wrapper" className="App">
						<NavMenu />

						<div className={contentClassName}>
							<Component {...matchProps} />
						</div>

					</div> : <Redirect to="/" />)} />
		</div>
	);
};

const mapStateToProps = state => ({
	permissions: state.account.permissions
});

export default connect(mapStateToProps)(AppLayoutRoute);


// WEBPACK FOOTER //
// ./src/components/Layout/AppLayoutRoute.js